import { ALERT_SET_MESSAGE, ALERT_SHOW } from './constants';

export const showMessage = message => dispatch => {
  dispatch({
    type: ALERT_SET_MESSAGE,
    payload: message,
  });
  dispatch({
    type: ALERT_SHOW,
    payload: true,
  });
};
